var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWarning = function SvgWarning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "width",
    height: "height",
    fill: "none",
    viewBox: "0 0 28 25"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11.13 2.434 1.295 19.518c-1.379 2.394.344 5.387 3.101 5.387h19.67c2.757 0 4.48-2.993 3.101-5.387L17.332 2.434C15.954.04 12.508.04 11.13 2.434L1.295 19.518c-1.379 2.394.344 5.387 3.101 5.387h19.67c2.757 0 4.48-2.993 3.101-5.387L17.332 2.434C15.954.04 12.508.04 11.13 2.434"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F2F0F4",
    d: "M14.415 21.596a2.206 2.206 0 1 0 0-4.412 2.206 2.206 0 0 0 0 4.412M14.782 14.242h-.736c-.61 0-1.103-.52-1.103-1.16V8.784c0-.641.494-1.16 1.103-1.16h.736c.61 0 1.103.519 1.103 1.16v4.296c0 .642-.494 1.161-1.103 1.161"
  })));
};
export default SvgWarning;